/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListSigintSignalsResult,
  ListSigintSignalsResult$inboundSchema,
} from "../components/listsigintsignalsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListSigintSignalsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListSigintSignalsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListSigintSignalsSecurity = {
  option1?: ListSigintSignalsSecurityOption1 | undefined;
  option2?: ListSigintSignalsSecurityOption2 | undefined;
};

export type ListSigintSignalsRequest = {
  /**
   * Signal ID after which to continue
   */
  cursor?: string | undefined;
  /**
   * Page size
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListSigintSignalsResponse = {
  result: ListSigintSignalsResult;
};

/** @internal */
export type ListSigintSignalsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListSigintSignalsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListSigintSignalsSecurityOption1$Outbound,
  ListSigintSignalsSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listSigintSignalsSecurityOption1ToJSON(
  listSigintSignalsSecurityOption1: ListSigintSignalsSecurityOption1,
): string {
  return JSON.stringify(
    ListSigintSignalsSecurityOption1$outboundSchema.parse(
      listSigintSignalsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListSigintSignalsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListSigintSignalsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListSigintSignalsSecurityOption2$Outbound,
  ListSigintSignalsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listSigintSignalsSecurityOption2ToJSON(
  listSigintSignalsSecurityOption2: ListSigintSignalsSecurityOption2,
): string {
  return JSON.stringify(
    ListSigintSignalsSecurityOption2$outboundSchema.parse(
      listSigintSignalsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListSigintSignalsSecurity$Outbound = {
  Option1?: ListSigintSignalsSecurityOption1$Outbound | undefined;
  Option2?: ListSigintSignalsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListSigintSignalsSecurity$outboundSchema: z.ZodMiniType<
  ListSigintSignalsSecurity$Outbound,
  ListSigintSignalsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListSigintSignalsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListSigintSignalsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listSigintSignalsSecurityToJSON(
  listSigintSignalsSecurity: ListSigintSignalsSecurity,
): string {
  return JSON.stringify(
    ListSigintSignalsSecurity$outboundSchema.parse(listSigintSignalsSecurity),
  );
}

/** @internal */
export type ListSigintSignalsRequest$Outbound = {
  cursor?: string | undefined;
  limit: number;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListSigintSignalsRequest$outboundSchema: z.ZodMiniType<
  ListSigintSignalsRequest$Outbound,
  ListSigintSignalsRequest
> = z.pipe(
  z.object({
    cursor: z.optional(z.string()),
    limit: z._default(z.int(), 50),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listSigintSignalsRequestToJSON(
  listSigintSignalsRequest: ListSigintSignalsRequest,
): string {
  return JSON.stringify(
    ListSigintSignalsRequest$outboundSchema.parse(listSigintSignalsRequest),
  );
}

/** @internal */
export const ListSigintSignalsResponse$inboundSchema: z.ZodMiniType<
  ListSigintSignalsResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListSigintSignalsResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listSigintSignalsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListSigintSignalsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSigintSignalsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSigintSignalsResponse' from JSON`,
  );
}
